import { useRef } from 'react'
// import { HondaNavi, Polaris, PolarisPro, Skidoo, Super73, Yamaha450,  Suzuki, Model358, , , Model223 } from './ModelComponents'
import { Model174, Model193, Model349, Model363, Model378 } from './ModelComponents'
import { state } from '../context/store'



const CurrentModel = ({ activeSeat }) => {



    // This is the main motorcycle seat 
    if (activeSeat === "motorcycle") {


        return (
            <Model174 />
        )
    }

    // This is the main ATV seat Model (AKA Raptor 700)
    if (activeSeat === "atv") {

        return (
            <Model193 />
        )
    }

    // This is the eBike1 seat Model (AKA Surron)
    if (activeSeat === "ebike1")
    {
        console.log("eBike1: ", activeSeat)

        return (
            <Model349 />
        )
    }


    // This is the scooter seat Model (AKA Honda Navi)
    if (activeSeat === "scooter") {

        return (
            <Model363 />
        )
    }
    // This is the eBike2 seat Model (AKA Super 73)
    if (activeSeat === "ebike2") {

        return (
            <Model378 />
        )
    }



}

const Experience = () => {

    const activeSeat = state.current.initialChoices.threeDModel

    if (activeSeat) {
        return (
            <CurrentModel activeSeat={activeSeat} />
        )
    }

}

export default Experience


